<template>
<div>
  <v-card>
    <v-card-text>
      <h1 class="mb-5">DOCUMENTOS</h1>
      <p class="text-justify">
        Debe presentar los siguientes documentos físicamente en original y/o copia
        para su revisión por parte del personal del Instituto.
      </p>
      <p class="text-justify">
        En caso de que no sea uno de los padres de familia quien acuda por la ficha, 
        presentar un documento donde esté autorizado a realizar el proceso de admisión; 
        al igual que una identificación de la persona que autorizó y de quien acude a comprar la ficha.
      </p>
      <v-simple-table class="elevation-0">
        <template v-slot:default>
          <thead>
            <tr class="accent lighten-4 py-1">
              <th>Documento</th>
              <th>Original</th>
              <th>Copia</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(documento, i) in lst_documentos" :key="i">
              <td>{{ documento.nombre }}</td>
              <td>
                <v-icon v-show="parseInt(documento.original) === 1" color="primary"
                  >mdi-check-circle</v-icon
                >
              </td>
              <td>
                <v-icon v-show="parseInt(documento.copia) === 1" color="primary"
                  >mdi-check-circle</v-icon
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions class="mobil-botones">
      <v-spacer></v-spacer>
      <v-btn  class="mr-3 white--text" style="background: linear-gradient(0deg, rgba(112,112,112,1) 0%, rgba(156,153,153,1) 100%);" @click="dialogRegresar=true" rounded large>
        <v-icon class="mr-2">mdi-arrow-left</v-icon>REGRESAR
      </v-btn>
      <v-btn  class="mr-3 white--text" style="background: linear-gradient(0deg, rgba(241,37,53,1) 0%, rgba(255,105,105,1) 100%)" rounded large @click="dialogSalir=true">
        <v-icon class="mr-2">mdi-close-box</v-icon>SALIR
      </v-btn>
      <v-btn
        class="white--text"
        style="background: linear-gradient(0deg, rgba(117,2,173,1) 0%, rgba(159,105,186,1) 100%)"
             rounded
             large
        @click="dialog=true">
        <v-icon class="mr-2">mdi-content-save</v-icon>CONTINUAR Y GUARDAR
      </v-btn>
    </v-card-actions>
  </v-card>

<!-- REGISTRO CREADO -->
    <v-dialog v-model="dialog" width="450" persistent>
      <v-card>
        <v-card-text class="pt-10 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Registro actualizado con éxito
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              Tu información del <b>paso 4</b> ha sido guardada.
            </p>
            <p class="text-justify">
              Clic en [ACEPTAR] para continuar.
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="bachillerato" dark
              @click="$emit('emit-next',5), dialog = false">
            <v-icon>mdi-check</v-icon>
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / REGISTRO CREADO -->
    <!-- SALIR -->
    <v-dialog v-model="dialogSalir" width="450" persistent>
      <v-card>
        <v-card-text class="pt-10 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Salir 
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              ¿Esta seguro de <b>no continuar</b> con la captura?
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error" dark
              @click="dialogSalir = false">
            <v-icon>mdi-close-box-outline</v-icon>
            NO
          </v-btn>
          <v-btn class="bachillerato" dark
              @click="$emit('emit-salir'), dialogSalir = false">
            <v-icon>mdi-check</v-icon>
            SÍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / SALIR -->
    <!-- REGRESAR -->
    <v-dialog v-model="dialogRegresar" width="450" persistent>
      <v-card>
        <v-card-text class="pt-10 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Regresar 
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              ¿Esta seguro de <b>no continuar</b> con la captura?
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error" dark
              @click="dialogRegresar = false">
            <v-icon>mdi-close-box-outline</v-icon>
            NO
          </v-btn>
          <v-btn class="bachillerato" dark
              @click="$emit( 'emit-last', 3 ), dialogRegresar = false">
            <v-icon>mdi-check</v-icon>
            SÍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / REGRESAR -->
</div>
</template>

<script setup>
import { onMounted, ref,getCurrentInstance } from 'vue';
import axios from 'axios'

const root=getCurrentInstance().proxy

    const lst_documentos=ref([])
    const dialog=ref(false)
    const dialogSalir=ref(false)
    const dialogRegresar=ref(false)

    onMounted(()=>{getDocumentos()})

    async function getDocumentos(){
      let grado =root.$ls.get('grado',0)
      let {data}=await axios.get(`precaptura/getDocumentos/${grado}`)
      lst_documentos.value=data
    }


</script>


<style scoped>
@media (max-width: 600px) {
.mobil-botones{
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.mobil-botones button{
  width: 100%;
  margin-left: 0!important;
  margin-right: 0!important;
}
}
</style>
